import type {
  ApiSourceLabelPair,
  SelectionSchemaMeasurePoint,
  Source,
  SourceMap
} from '@highimpact-frontend/api-types';

/** Builds the canonical source-map key for a measure-point / measure-type pair. */
export const toSourceLabelKey = (
  measurePointId: number,
  measureTypeId: number
): string => `mp:${measurePointId}:mt:${measureTypeId}`;

/** Reads a resolved source for one pair from a source map. */
export const getSourceFromMap = (
  sourceMap: SourceMap,
  pair: ApiSourceLabelPair
): Source | undefined =>
  sourceMap[toSourceLabelKey(pair.measure_point_id, pair.measure_type_id)];

/** Reads the display label for one pair from a source map. */
export const getSourceLabelFromMap = (
  sourceMap: SourceMap,
  pair: ApiSourceLabelPair
): string | undefined => getSourceFromMap(sourceMap, pair)?.label;

/** Resolves ordered sources for measure-point paths from a source map. */
export const resolveSourcesFromMap = (
  paths: readonly SelectionSchemaMeasurePoint[],
  sourceMap: SourceMap
): Source[] =>
  paths
    .map((path) => getSourceFromMap(sourceMap, path))
    .filter((source): source is Source => source !== undefined);
